module.exports = __webpack_public_path__ + "static/media/logo_footer.7f7cd5ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/logo_footer.png
// module id = 797
// module chunks = 1